import React ,{Component } from 'react';
import CertReqPayment from '../views/certreqpayment';
import { alertActions,certpaymentActions,physicianActions, patientActions,certrequestActions,certificationReferenceActions,certificationTypeActions,certificationTypeGroupActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";

class CertPaymentContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isNextStepPayment:false
         }
        this.submit = this.submit.bind(this);
        this.submitPayment=this.submitPayment.bind(this); 
        this.updatePayment=this.updatePayment.bind(this); 
    }
    
    submit(event) {

        event.preventDefault();
       
        const { dispatch } = this.props;
       
        this.setState({
            isNextStepPayment:true
        })

        const { obj } = this.props;
        const { CertReq}=obj;

        if(CertReq && CertReq.CertificationPayments)
        {
            console.log('aa',CertReq.CertificationPayments.filter(x=>x.PaymentState!=3))
            if(CertReq.CertificationPayments.filter(x=>x.PaymentState!=3).length !=0)
            {
                dispatch(alertActions.error('لطفا پرداخت ها را تکمیل نمایید'));
            }else{
                history.push('/showcertrequestsimple/'+CertReq.Id)
            }
        }
      //  dispatch(certrequestActions.get(certreqId));

       
     
    }

    submitPayment(model)
    {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;

        dispatch(certpaymentActions.edit(model,model.Id,certrequestActions.get(certreqId)));
      //  dispatch(certrequestActions.get(certreqId));

    }

    
    updatePayment(model)
    {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;

        dispatch(certpaymentActions.postbill(model,certrequestActions.get(certreqId)));
       // dispatch(certrequestActions.get(certreqId));

    }

  

    componentDidMount(){
       

       const {certreqId}=this.props.match.params;

       console.log('Props',this.props);

       const { dispatch } = this.props;   

        if (certreqId) {

            let id = certreqId;
             
            dispatch(certrequestActions.get(id));     
        
        } 
    
       
    }

    render() { 

        const { type,obj,items } = this.props;
        console.log('Items',items);
        console.log('OBJ+',obj)
        if(type==objConstants.ADD_SUCCESS)
        {
            console.log('Added successfully');
          //  history.push('/certrequestlist')
        }
        if(type==objConstants.UPDATE_SUCCESS)
        {
           // console.log('Updated successfully');
           // history.push('/patients')
        }
     
        return ( 
            <CertReqPayment submitPaymentHandler={this.submitPayment} updatePaymentHandler={this.updatePayment} submitHandler={this.submit} model={(obj!=null && obj.CertReq!=null)?obj.CertReq:null}   {...this.props}  ref="child" />
         );
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items,error } = state.objs;
    
   console.log('STATE++++++++++',item)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items,
        error
      
        
    };
} 

export default withRouter(connect(mapStateToProps)(CertPaymentContainer));